import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHealthOccupationStart,
  getHealthOccupationSuccess,
  getHealthOccupationFailure,
} from "../reducers/getHealthOccupationReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHealthOccupation = createAsyncThunk(
  "getHealthOccupation",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHealthOccupationStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Health/GetOccupations`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHealthOccupationSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(
        getHealthOccupationFailure(error.response.data.Message)
      );
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
